import { useNavigate } from 'react-router-dom';
import ComposeMessage from 'src/sections/view_message/ComposeMessage';
import ViewMessageContextProvider from 'src/sections/view_message/ViewMessageContextUnified';

const ComposeMessagePage = () => {
  const navigate = useNavigate();

  const handleNavigateBack = () => {
    navigate('/view-messages-outbox');
  };

  return (
    <ViewMessageContextProvider initialMode="generic">
      <ComposeMessage isStandalone={true} onNavigateBack={handleNavigateBack} />
    </ViewMessageContextProvider>
  );
};

export default ComposeMessagePage;
